export default __webpack_public_path__ + "static/media/default-banner.99730d23.jpg";